$('.pnr_buy').click(function(){
    window.open('https://store.oxva.com/products/oxva-velocity-le-kit');
})
$('.pnr_cart').click(function(){
    var element = document.querySelector(".velocity_section7");
    element.scrollIntoView({block: "start"});
})
$('.pnr_spec').click(function(){
    var element = document.querySelector(".velocity_section9");
    element.scrollIntoView({block: "end"});
})

//section3
var products=document.getElementsByClassName('box3_product_list');
products[0].classList.add("img1");
products[1].classList.add("img2");
products[2].classList.add("img3");
products[3].classList.add("img4");
var box3=document.getElementsByClassName('box3');
var s6Controller = new ScrollMagic.Controller();
var removeclass=0;
for(removeclass;removeclass<11;removeclass++){
      box3[0].classList.remove("step"+removeclass);
      //console.log(removeclass);
     }

new ScrollMagic.Scene({
    triggerElement: '.velocity_section3',
    duration: "30%",
    triggerHook: 0,
    offset: "0"
  })
  .setPin('.velocity_section3') // pins the element for the the scene's duration
  .addTo(s6Controller) // assign the scene to the controller
  .on("progress", function (e) {
     const scrollIndex = Math.floor(e.progress.toFixed(3) * 10);
     //console.log(scrollIndex);
     var i=0;
     for(i;i<10;i++){
      box3[0].classList.remove("step"+i);
     }
     box3[0].classList.add("step"+scrollIndex);
  });

  //section11
  
const allIcons = document.querySelectorAll('.originse_section11 .glide__bullet');


// event listeners
allIcons.forEach(el =>{
    el.addEventListener('mouseenter', ()=>{
        el.closest(".glide__bullet").click();
    });
})
new Glide('.glide',{
    gap: 0
}).mount();